var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mod-bubble",style:(_vm.cptStyle)},[_c('div',{staticClass:"content",class:_vm.meta.pos,domProps:{"innerHTML":_vm._s(_vm.meta.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }